import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';
import { getFavoritesRequestParams } from '../common/favoritesServiceHelper';

export function getProductReleases() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_full_product_releases'
      })
    }
  );
}

export function getProductReleaseById(productReleaseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_product_release_by_id',
        id: productReleaseId,
      })
    }
  );
}

export function addProductRelease(productName, productVersion, releaseDate = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'add_product_release',
        product_name: productName,
        product_version: productVersion,
        release_date: releaseDate
      })
    }
  );
}

export function updateProductRelease(id, productName, productVersion, releaseDate = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'update_product_release',
        id,
        product_name: productName,
        product_version: productVersion,
        release_date: releaseDate
      })
    }
  );
}

export function getProductReleaseHistory(productReleaseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_product_release_history',
        product_release_id: productReleaseId
      })
    }
  );
}

export function getProductReleaseHistoryById(productReleaseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_product_release_history_by_id',
        id: productReleaseId
      })
    }
  );
}

export function addProductReleaseToFavorites(productReleaseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'product_release', 'add', productReleaseId
    )
  );
}

export function removeProductReleaseFromFavorites(productReleaseId = null) {
  return sendRequestWithAuth(
    settings.ServerURL, getFavoritesRequestParams(
      'product_release', 'remove', productReleaseId
    )
  );
}



// WEBPACK FOOTER //
// ./src/services/productReleases.js